"use client";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type Props = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	planName: string;
	isLoading?: boolean;
	onConfirm: () => void;
};

export default function PlanDowngradeConfirmDialog({
	open,
	onOpenChange,
	planName,
	isLoading = false,
	onConfirm,
}: Props) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="border border-[color:var(--glass-border)] bg-[var(--glass-background)] text-white shadow-[var(--glass-shadow)] backdrop-blur-xl [-webkit-backdrop-filter:var(--glass-backdrop-filter)] [backdrop-filter:var(--glass-backdrop-filter)] dark:border-[color:var(--glass-border)] dark:bg-[rgba(11,21,27,0.72)] sm:max-w-lg sm:rounded-2xl"
				closeClassName="text-white opacity-90 hover:opacity-100"
			>
				<DialogHeader>
					<DialogTitle className="text-white">Schedule plan downgrade</DialogTitle>
					<DialogDescription className="text-white/90">
						Your current plan will cancel at the end of this billing period. Your
						account will then move to{" "}
						<span className="font-semibold text-white">{planName}</span>{" "}
						automatically.
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="gap-3 sm:gap-3">
					<button
						type="button"
						onClick={() => onOpenChange(false)}
						disabled={isLoading}
						className="text-sm font-semibold text-white/90 transition-colors hover:text-white disabled:opacity-50"
					>
						Cancel
					</button>
					<Button onClick={onConfirm} disabled={isLoading}>
						Confirm downgrade
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
